import { render, staticRenderFns } from "./PdfResourceViewer.vue?vue&type=template&id=164ffbb8&"
import script from "./PdfResourceViewer.vue?vue&type=script&lang=js&"
export * from "./PdfResourceViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports